import React, { useEffect, useRef, useReducer } from "react";
import { Modal, Button, Form, Spinner, Alert } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import useAuth from "../../hooks/useAuth";
export default function TwoFactorAuth({ setTwoFAModal, resendCode, callback, length, mode }) {
  const [countdown, setCountdown] = React.useState(0);
  length = length || 6;

  useEffect(() => {
    setCountdown(60);
  }, [])
  useEffect(() => {
    countdown > 0 && setTimeout(() => setCountdown(countdown - 1), 1000)
  }, [countdown])

  const forceKeyPressUppercase = (e, setFieldValue) => {
    let el = e.target;
    setFieldValue('code', el.value.toUpperCase())
  };

  const {dispatchTwoFactorAuth} = useAuth()
  return (
    <Modal
      onHide={() => setTwoFAModal(false)}
      show={true}
      centered
      size="md"
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header>
        <Modal.Title>Two-Factor Authentication</Modal.Title>
        <Button
          variant="danger"
          size="sm"
          className="py-0"
          onClick={() => setTwoFAModal(false)}
        >
          x
        </Button>
      </Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={{
            code: "",
            submit: false,
          }}
          validationSchema={Yup.object().shape({
            code: Yup.string().min(length).max(length).required("Verification code is required"),
          })}
          onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
            try {
              await callback(values.code)
              setSubmitting(false);
            } catch (error) {
              const message = error.message || "Something went wrong";
              setStatus({ success: false });
              setErrors({ submit: message });
              setSubmitting(false);
            }
          }}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            isSubmitting,
            touched,
            values,
            setErrors,
            setStatus,
            setSubmitting,
            setFieldValue
          }) => (
            <Form onSubmit={handleSubmit}>
              {errors.submit ? (
                <Alert className="my-3" variant="danger">
                  <div className="alert-message">{errors.submit}</div>
                </Alert>
              ) : (
                <Alert className="my-3" variant="info">
                  <div className="alert-message">You have been sent an {length}-character code {mode || "in your email"}</div>
                </Alert>
              )}

              <Form.Group className="mb-3">
                <Form.Label className="text-light-gray">
                  Verification Code
                </Form.Label>
                <Form.Control
                  size="lg"
                  type="text"
                  name="code"
                  onKeyUp={(e) => forceKeyPressUppercase(e, setFieldValue)}
                  minLength={length}
                  maxLength={length}
                  placeholder="Enter verification code"
                  value={values.code}
                  isInvalid={Boolean(touched.code && errors.code)}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
                {!!touched.code && (
                  <Form.Control.Feedback type="invalid">
                    {errors.code}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
              <div className="text-center mt-3 d-flex gap-3">
                <Button
                  type="button"
                  variant="secondary w-50"
                  size="lg"
                  onClick={() => { setCountdown(60); resendCode() }}
                  disabled={countdown}
                >
                  Resend { countdown > 0 ? `in ${countdown.toString().length === 1 ? "0" : ''}${countdown}` : ''}
                </Button>
                <Button
                  type="submit"
                  variant="primary w-100"
                  size="lg"
                  disabled={isSubmitting}
                >
                  Verify
                  {isSubmitting && (
                    <Spinner
                      className="ms-1"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
}
